module.exports = __webpack_public_path__ + "img/no_data.4b214748.png";